/**
 * 商品规格里「可选糖 / 温度偏好」的预设选项。
 *
 * 这两组是标准化的点单属性，做成下拉可以避免运营手输错别字、小程序上千奇百怪；
 * 顺序有意义：小程序默认选中每组的第一项，所以把最常用的口味排在前面。
 */
export const SUGAR_SPEC_PRESET_NAMES = ['标准糖', '少糖', '五分糖', '七分糖']
export const TEMPERATURE_SPEC_PRESET_NAMES = ['少冰', '去冰', '常温', '热饮']

/** 规格组 id → 预设选项名；自建的规格组返回空数组，仍然手输。 */
export function specPresetNames(groupId: string): string[] {
  if (groupId === 'sugar') return [...SUGAR_SPEC_PRESET_NAMES]
  if (groupId === 'temperature') return [...TEMPERATURE_SPEC_PRESET_NAMES]
  return []
}
